module.exports = __webpack_public_path__ + "static/media/splash.5407969a.png";